import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Box, Button, Text } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { changeValueOfArrayImmutable } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";

import ComponentCustomer from "./ComponentCustomer";
import ComponentNomorJemput from "./ComponentNomorJemput";
import ComponentAlamat from "./ComponentAlamat";
import ComponentBarang from "./ComponentBarang";
import ComponentDeliveryUtils from "./ComponentDeliveryUtils";

const DeliveryJemputNotaBasicData = ({
    stateData,
    fnRefreshIndex,
    fnCloseDrawer,
    fnSuccessSubmit,
    fnSuccessBatal
}) => {

    const mountedRef = React.useRef(true);

    const { URI1 } = useParams();

    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'deliveryJemputNotaBasicData-1',

        successSubmitNota: 'deliveryJemputNotaBasicData-10',
        errorSubmitNota: 'deliveryJemputNotaBasicData-11',
    })

    const [data, setData] = React.useState({
        data: [],
        dataFlag: 'idle',
        dataInitLoading: false,

        customerId: '',

        barang: {
            dataBarangCategory: [],
        },

        submitNota: {
            modal: false,
            trxId: '',
            submitLoading: false,
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        if (URI1) {

            setData(d => ({ ...d, dataInitLoading: true }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('flag_all', utils.flagAll);
            formDT.append('customer_id', URI1);
            formDT.append('current_step', stateData.utilsRef.currentStep);
            formDT.append('is_cancel', stateData.utilsRef.isCancel);

            formDT.append('alamat_selector_selected', utils.alamatSelector.default.value);

            axios({
                method: 'post',
                url: BE_API_THREE + '/data_init_delivery_penjemputan',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, dataInitLoading: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        data: response.data.data,
                        dataFlag: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? true : false,

                        barang: {
                            ...d.barang,
                            dataBarangCategory: response.data.data_barang_category
                        },

                        customerId: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['customer_id'] : '',
                    }))
                }

                if (response.data.flag === 'new') {
                    fnRefreshIndex();
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorGetData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data-customer') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data customer tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'id-not-enough') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Kode ID Penjemputan sudah tidak dapat ditambahkan lagi. Mulai kembali proses pada hari esok.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    dataInitLoading: false
                }))

                notifications.show({
                    id: notificationId.current.errorGetData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext, loginContext.syswebapp, URI1, stateData.utilsRef.currentStep, stateData.utilsRef.isCancel, fnRefreshIndex])

    const handleSubmitNota = () => {
        setData(d => ({ ...d, submitNota: { ...d.submitNota, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', data.submitNota.trxId);
        formDT.append('current_step', stateData.utilsRef.currentStep);
        formDT.append('is_cancel', stateData.utilsRef.isCancel);

        formDT.append('next_step', utils.penjemputanSteps.segera_menjemput.value);
        formDT.append('alamat_selector', JSON.stringify(utils.alamatSelector));

        axios({
            method: 'post',
            url: BE_API_THREE + '/submit_nota_penjemputan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitNota: { ...d.submitNota, submitLoading: false, modal: false } }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({ ...d, submitNota: { ...d.submitNota, trxId: '' } }));

                notifications.show({
                    id: notificationId.current.successSubmitNota,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Submit Data',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })

                fnCloseDrawer();
                fnSuccessSubmit();
            }

            if (response.data.flag_status === 'not-complete-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: response.data.message,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitNota,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                fnCloseDrawer();

                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitNota: { ...d.submitNota, submitLoading: false, modal: false } }));

            notifications.show({
                id: notificationId.current.errorSubmitNota,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            {data.dataInitLoading &&
                <PaperWrapper stateMT="1rem">
                    <Text size='sm' color="dimmed">Loading Data..</Text>
                </PaperWrapper>
            }

            {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length <= 0) &&
                <PaperWrapper stateMT="1rem">
                    <Text size='sm' color="dimmed">No Data</Text>
                </PaperWrapper>
            }

            {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((keyD, indexD) => {
                return (
                    <React.Fragment key={keyD}>
                        <ComponentCustomer
                            stateData={data.data[keyD]}
                        />

                        <ComponentNomorJemput
                            stateData={data.data[keyD]}
                            utilsRef={{
                                currentStep: stateData.utilsRef.currentStep,
                                isCancel: stateData.utilsRef.isCancel
                            }}
                            fnCloseDrawer={fnCloseDrawer}
                            fnSuccessBatal={fnSuccessBatal}
                        />

                        <ComponentAlamat
                            stateData={data.data[keyD]}
                            stateKey={keyD}
                            utilsRef={{
                                currentStep: stateData.utilsRef.currentStep,
                                isCancel: stateData.utilsRef.isCancel
                            }}

                            fnCloseDrawer={fnCloseDrawer}
                            fnSubmitAlamatSelector={(stateKey, stateProp, stateVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, stateVal),
                                }))
                            }}

                            fnSubmitAlamatLain={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }))
                            }}
                        />

                        <ComponentBarang
                            dataDataKey={data.data[keyD]}
                            dataCategoryBarang={data.barang.dataBarangCategory}
                            stateKey={keyD}
                            stateCustomerId={data.customerId}
                            utilsRef={{
                                currentStep: stateData.utilsRef.currentStep,
                                isCancel: stateData.utilsRef.isCancel
                            }}

                            fnCloseDrawer={fnCloseDrawer}

                            fnBarangPackage={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }));

                                fnRefreshIndex();
                            }}

                            fnBarang={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }));

                                fnRefreshIndex();
                            }}

                            fnBarangDelete={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }));

                                fnRefreshIndex();
                            }}
                        />

                        <ComponentDeliveryUtils
                            dataDataKey={data.data[keyD]}
                            stateKey={keyD}
                            utilsRef={{
                                currentStep: stateData.utilsRef.currentStep,
                                isCancel: stateData.utilsRef.isCancel
                            }}

                            fnCloseDrawer={fnCloseDrawer}
                            fnRefreshIndex={fnRefreshIndex}

                            fnDeliveryMan={(stateKey, object) => {
                                const newValue = data.data.map((obj, idx) => {
                                    if (Number(idx) === Number(stateKey)) {
                                        return {
                                            ...obj,
                                            delivery_man_id: object ? object.id : null,
                                            delivery_man_name: object ? object.name : null,
                                            delivery_man_gender: object ? object.gender : null,
                                            delivery_man_level: object ? object.level : null,
                                            delivery_man_sub_level: object ? object.subLevel : null,
                                            delivery_man_is_active: object ? object.isActive : null,
                                        };
                                    }

                                    return obj;
                                })

                                setData(d => ({ ...d, data: newValue }));
                            }}

                            fnWaktuPenjemputan={(stateKey, newVal) => {
                                const newValue = data.data.map((obj, idx) => {
                                    if (Number(idx) === Number(stateKey)) {
                                        return {
                                            ...obj,
                                            waktu_jemput: newVal,
                                        };
                                    }

                                    return obj;
                                })

                                setData(d => ({ ...d, data: newValue }));
                            }}

                            fnKeterangan={(stateKey, newVal) => {
                                const newValue = data.data.map((obj, idx) => {
                                    if (Number(idx) === Number(stateKey)) {
                                        return {
                                            ...obj,
                                            keterangan: newVal,
                                        };
                                    }

                                    return obj;
                                })

                                setData(d => ({ ...d, data: newValue }));
                            }}
                        />

                        <Box
                            mt='1.5rem'
                            mb='2rem'
                        >
                            <Text
                                color="dimmed"
                                size='sm'
                                mb='sm'
                            >
                                Nota penjemputan yang sudah disubmit akan dapat dilakukan penjemputan oleh delivery man.
                            </Text>

                            <Button
                                fullWidth
                                color="blue"
                                onClick={() => setData(d => ({
                                    ...d,
                                    submitNota: {
                                        ...d.submitNota,
                                        trxId: data.data[keyD].delivery_jemput_id,
                                        modal: true
                                    }
                                }))}
                            >
                                Submit Nota Penjemputan
                            </Button>
                        </Box>
                    </React.Fragment>
                )
            })}

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.submitNota.modal}
                fnHide={() => setData(d => ({ ...d, submitNota: { ...d.submitNota, modal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.submitNota.submitLoading}
                fnButtonAction={handleSubmitNota}
            >
                <Text size='sm' color="dimmed">Submit Nota ?</Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default React.memo(DeliveryJemputNotaBasicData);